//Basic dividier - full page width and white in color

function Divider() {
  return (
    <div className="relative w-full pb-6">
      <div className="flex items-center justify-center">
        <div className="w-full border-t border-gray-300"/>
      </div>
    </div>
  )
}

export default Divider